import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { combineLatest, filter, map, Observable, switchMap } from 'rxjs';
import { AUTH_REDUCER } from '../../store/reducers/auth.reducer';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';

export const signInGuard: CanMatchFn = (): Observable<UrlTree | boolean> => {
  const router = inject(Router);
  const store = inject(Store);

  return combineLatest([
    store.select(AUTH_REDUCER.selectDiscoveryDocumentLoaded),
    store.select(AUTH_REDUCER.selectUserProfileLoaded),
  ]).pipe(
    filter(([docLoaded, userLoaded]) => docLoaded && userLoaded),
    switchMap(() => store.select(AUTH_REDUCER.selectAuthenticated)),
    map((isAuth) => (isAuth ? router.createUrlTree(['']) : true)),
  );
};
